/* eslint-disable import/prefer-default-export */
import dayjs, { ManipulateType } from 'dayjs';
import * as yup from 'yup';

export const dateDisplayFormat = 'D MMM YYYY';

export const yupMethods = () => {
  yup.addMethod<yup.DateSchema>(yup.date, 'minDOBDate', function (this: yup.DateSchema, duration: number, name: ManipulateType, errorMessage) {
    return this.test('petDateOfBirth', errorMessage, function (value) {
      // console.log('minDOBDate', value, this, errorMessage);
      const { path, createError } = this;

      const minDate = dayjs().add(-duration, name);
      if (dayjs(value).isAfter(minDate)) {
        console.log('DOB should be before', minDate.format());
        return createError({ path, message: errorMessage });
      }

      return true;
    });
  });

  yup.addMethod<yup.DateSchema>(yup.date, 'maxDOBDate', function (this: yup.DateSchema, duration: number, name: ManipulateType, errorMessage) {
    return this.test('petDateOfBirth', errorMessage, function (value) {
      // console.log('maxDOBDate', value, this, errorMessage);
      const { path, createError } = this;

      const minDate = dayjs().add(-duration, name);
      if (dayjs(value).isBefore(minDate)) {
        console.log('DOB should be after', minDate.format());
        return createError({ path, message: errorMessage });
      }

      return true;
    });
  });
};
